import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

/**
 * v1's single `PayerPayeeEngagement` audit resource is two resources on v3, one
 * per side of the relationship. This is the payee's view of a client, so the id
 * is a `payerEngagementId` and the trail lives under `PayerEngagement`.
 */
export function usePayerEngagementHistoryResources(
  payerEngagementId: string
): AuditLogResource[] {
  return useMemo(
    () => [
      {
        resourceType:
          ListAuditLogsFilterParameterResourceTypeEq.PAYER_ENGAGEMENT,
        resourceId: payerEngagementId
      }
    ],
    [payerEngagementId]
  );
}
